// extracted by mini-css-extract-plugin
export default {"infoWrapper":"DetailsInfoWrapper_infoWrapper__-vcFM","infoWrapper__item":"DetailsInfoWrapper_infoWrapper__item__lwwr-","appear":"DetailsInfoWrapper_appear__OyPPZ"};